import { Navigate, useParams } from "react-router-dom"

import { useClientContext } from "../common/ClientContext"
import { USER_ACCOUNT_LOADING_STATUS } from "../Default/common/constant"
import { getRedirectLink } from "../Default/parseQuery"

import { Content } from "./Content"
import { COMPANIES } from "./common/constants"

import { APP_PAGE_URL } from "utils/env-management"
import { Spinner } from "components/Spinner"
import { PageHeader } from "components/Header/PageHeader"
import { Footer, Layout } from "components"
import { logEvent } from "utils/helpers"
import { useDidMount } from "utils/customHooks"

export function ClientCompanyAuthorizationPage() {
    const [{ loading, isVerified }] = useClientContext()
    const { id } = useParams<{ id: COMPANIES }>()

    useDidMount(() => {
        if (isVerified) {
            logEvent({ event: "Client signed in" })
        }
    })

    if (loading !== USER_ACCOUNT_LOADING_STATUS.READY) {
        return (
            <Layout className="profile">
                <Spinner />
            </Layout>
        )
    }

    if (isVerified) {
        return <Navigate to={getRedirectLink() ?? "/my/alter"} />
    }
    return (
        <Layout className="profile">
            <PageHeader
                openLogo={
                    id === COMPANIES.DODO
                        ? {
                              url: `${APP_PAGE_URL}/dodopizza`,
                              newTab: true,
                          }
                        : undefined
                }
            />
            <Content />
            <Footer />
        </Layout>
    )
}
